<template>
  <header id="header">
    <div class="container">
      <a
        href="#"
        class="nav-opener"
        @click.prevent="isNavActive = !isNavActive"
      >
        <span>Menu</span>
      </a>
      <div
        :class="{ 'nav-active': isNavActive }"
        class="header-wrapper"
      >
        <div class="logo-frame">
          <div class="logo">
            <a href="#"><img
              src="@/../public/img/logo.png"
              alt="elsa zeit"
              width="239"
              height="53"></a>
          </div>
          <div class="powered-by">
            <span class="text-bold">powered by KI –</span><br>künstliche Intelligenz.
          </div>
        </div>
        <nav class="nav">
          <ul class="nav-drop">
            <li><a href="/">Startseite</a></li>
            <li><a href="/#objectives">Über uns</a></li>
            <li><a href="/#contact">Kontakt</a></li>
            <li><a href="/#price">Preise</a></li>
            <li><a href="/test">Test</a></li>
          </ul>
          <a
            class="btn btn-tryNow"
            href="/login">Anmelden</a>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HomeHeader',
  data () {
    return {
      isNavActive: false
    }
  }
}
</script>

<style scoped>

</style>
